import { Observable } from 'rxjs';

import { NotebookSidebarPreference } from '../notebook-sidebar.types';
import { OrgTypes } from '@mode/shared/contract-common';
import { NotebookType } from '../notebook.types';

export abstract class NotebookFacade {
  abstract notebookToken$: Observable<string>;
  abstract notebookType$: Observable<any>;
  abstract accountPreference$: Observable<any>;
  abstract accountContextPlanCode$: Observable<OrgTypes.PlanCode>;
  abstract updatePreference(preference: NotebookSidebarPreference): void;
  abstract updateNotebookType(notebookToken: string, notebookType: NotebookType): void;
  abstract createNotebook(reportToken: string): void;
}
